import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import AddProduct from '../../components/product/add-product/add-product.component';
import Button from '../../components/reusable/button/button.component';
import CategoryData from '../../components/category/category-data/category-data.component';
import CategoryImages from '../../components/category/category-images/category-images.component';
import ComponentModal from '../../components/reusable/component-modal/component-modal.component';
import ProductsTable from '../../components/reusable/tables/products-table/products-table.component';
import Spinner from '../../components/reusable/spinner/spinner.component';

import Client from '../../tools/client';

import {
    BackLink,
    ContentContainer,
    MainContainer,
    MainTitle
} from '../../styles/page.styles';

const client = new Client();

const CategoryPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [ loading, setLoading ] = useState(true);
    const [ category, setCategory ] = useState('');
    const [ products, setProducts ] = useState([]);
    const [ showAddProduct, setShowAddProduct ] = useState(false);

    useEffect(() => {
        getCategory();
        // eslint-disable-next-line
    }, []);

    const getCategory = async () => {
        setLoading(true);
        const res = await client.getCategoryById(id);
        setCategory(res);
        setProducts(res.Products);
        setLoading(false);
    };

    return (
        <MainContainer>
            <BackLink onClick={() => navigate(`/categories`)}>
                Back to Categories
            </BackLink>

            {loading ? (
                <Spinner />
            ) : category.length === 0 ? (
                <MainTitle>No Category to Display</MainTitle>
            ) : (
                <ContentContainer>
                    <MainTitle>Category - {category.name}</MainTitle>

                    <ComponentModal
                        isOpen={showAddProduct}
                        onClose={() => setShowAddProduct(false)}
                        title="Add Product"
                    >
                        <AddProduct
                            parentCategory={category}
                            onClose={() => setShowAddProduct(false)}
                            onSuccess={() => {
                                setShowAddProduct(false);
                                getCategory(); // Refresh to show new product
                            }}
                        />
                    </ComponentModal>

                    <CategoryImages category={category} getCategory={getCategory} />

                    <CategoryData category={category} getCategory={getCategory} />

                    <ContentContainer>
                        <ContentContainer margin={'0 0 20px 0'}>
                            <Button onClick={() => setShowAddProduct(true)}>
                                Add Product
                            </Button>
                        </ContentContainer>
                        <ProductsTable products={products} />
                    </ContentContainer>
                </ContentContainer>
            )}
        </MainContainer>
    );
};

export default CategoryPage;